import alt from "../alt";
import indexBy from "lodash/keyBy";
import LedgerUtil from "../utils/LedgerUtil";
import LedgerActions from "../actions/LedgerActions";
import UserStore from "../stores/UserStore";

class LedgerStore {
  constructor() {
    this.bindActions(LedgerActions);

    this.state = {
      isFetching: false,
      transactionsForOrder: {},
      analyticsTransactions: {},
      boxOfficeTransactions: {},
      venueTransactions: {},
      boxOfficeReport: [],
      transactionReport: [],
      venueReport: []
    };

    this.exportPublicMethods({
      getLedgerTransactionsForOrder: this.getLedgerTransactionsForOrder.bind(
        this
      ),
      getLedgerAnalyticsTransactions: this.getLedgerAnalyticsTransactions.bind(
        this
      ),
      getLedgerBoxOfficeTransactions: this.getLedgerBoxOfficeTransactions.bind(
        this
      ),
      getVenueTransactions: this.getLedgerVenueTransactions.bind(this),
      getLedgerBoxOfficeReport: this.getLedgerBoxOfficeReport.bind(this),
      getLedgerTransactionReport: this.getLedgerTransactionReport.bind(this),
      getLedgerVenueReport: this.getLedgerVenueReport.bind(this),
    });
  }

  getLedgerTransactionsForOrder(id) {
    return this.state.transactionsForOrder[id] || [];
  }

  // supports an array of event bucket ids
  getLedgerAnalyticsTransactions(idList) {
    if (!idList.length || idList.length === 0) {
      idList = Object.keys(this.state.analyticsTransactions);
    }
    let transactionsArray = [];
    for (let t = 0; t < idList.length; t++) {
      if (this.state.analyticsTransactions[idList[t]] !== undefined) {
        transactionsArray = transactionsArray.concat(
          this.state.analyticsTransactions[idList[t]]
        );
      }
    }
    return transactionsArray;
  }

  // supports an array of event bucket ids
  getLedgerBoxOfficeTransactions(idList) {
    if (!idList.length || idList.length === 0) {
      idList = Object.keys(this.state.boxOfficeTransactions);
    }
    let transactionsArray = [];
    for (let t = 0; t < idList.length; t++) {
      if (this.state.boxOfficeTransactions[idList[t]] !== undefined) {
        transactionsArray = transactionsArray.concat(
          this.state.boxOfficeTransactions[idList[t]]
        );
      }
    }
    return transactionsArray;
  }

  // supports an array of event bucket ids
  getLedgerVenueTransactions(idList) {
    if (!idList.length || idList.length === 0) {
      idList = Object.keys(this.state.boxOfficeTransactions);
    }
    let transactionsArray = [];
    for (let t = 0; t < idList.length; t++) {
      if (this.state.boxOfficeTransactions[idList[t]] !== undefined) {
        transactionsArray = transactionsArray.concat(
          this.state.boxOfficeTransactions[idList[t]]
        );
      }
    }
    return transactionsArray;
  }

  getLedgerBoxOfficeReport() {
    return this.state.boxOfficeReport;
  }

  getLedgerTransactionReport() {
    return this.state.transactionReport;
  }

  getLedgerVenueReport() {
    return this.state.venueReport;
  }

  onFetchLedgerTransactionsForOrder(id) {
    LedgerUtil.fetchLedgerTransactions(UserStore.getState().apiKey, {
      order: id
    })
      .then(data => {
        this.setState({
          transactionsForOrder: {
            ...this.state.transactionsForOrder,
            [id]: data.transactions
          }
        });
      })
      .catch(LedgerActions.fetchFailed);
  }

  onFetchLedgerAnalyticsTransactions(params) {
    this.setState({ isFetching: true });
    LedgerUtil.fetchLedgerAnalyticsTransactions(
      UserStore.getState().apiKey,
      params.conditions,
      params.options
    )
      .then(data => {
        this.setState({
          analyticsTransactions: {
            ...this.state.analyticsTransactions,
            [params.conditions.event_bucket]: data.data
          }
        });
        this.setState({ isFetching: false });
      })
      .catch(LedgerActions.fetchFailed);
  }

  onFetchLedgerBoxOfficeTransactions(params) {
    this.setState({ isFetching: true });
    LedgerUtil.fetchLedgerBoxOfficeTransactions(
      UserStore.getState().apiKey,
      params.conditions,
      params.options
    )
      .then(data => {
        this.setState({
          boxOfficeTransactions: {
            ...this.state.boxOfficeTransactions,
            [params.conditions.event_bucket]: data.data
          }
        });
        this.setState({ isFetching: false });
      })
      .catch(LedgerActions.fetchFailed);
  }

  onFetchLedgerVenueTransactions(params) {
    this.setState({ isFetching: true });
    LedgerUtil.fetchLedgerVenueTransactions(
      UserStore.getState().apiKey,
      params.conditions,
      params.options
    )
      .then(data => {
        this.setState({
          venueTransactions: {
            ...this.state.venueTransactions,
            [params.conditions.event_bucket]: data.data
          }
        });
        this.setState({ isFetching: false });
      })
      .catch(LedgerActions.fetchFailed);
  }

  onFetchLedgerVenueReport(params) {
    this.setState({ isFetching: true });
    LedgerUtil.fetchLedgerVenueReport(
      UserStore.getState().apiKey,
      params.conditions,
      params.options
    )
      .then(data => {
        this.setState({
          venueReport: data.data
        });
        this.setState({ isFetching: false });
      })
      .catch(LedgerActions.fetchFailed);
  }

  onFetchLedgerBoxOfficeReport(params) {
    this.setState({ isFetching: true });
    LedgerUtil.fetchLedgerBoxOfficeReport(
      UserStore.getState().apiKey,
      params.conditions,
      params.options
    )
      .then(data => {
        this.setState({
          boxOfficeReport: data.data
        });
        this.setState({ isFetching: false });
      })
      .catch(LedgerActions.fetchFailed);
  }

  onFetchLedgerTransactionReport(params) {
    this.setState({ isFetching: true });
    LedgerUtil.fetchLedgerTransactionReport(
      UserStore.getState().apiKey,
      params.conditions,
      params.options
    )
      .then(data => {
        this.setState({
          transactionReport: data.data
        });
        this.setState({ isFetching: false });
      })
      .catch(LedgerActions.fetchFailed);
  }

  onFetchFailed(e) {
    alert(`Fetching ledger data failed: ${e.message}`);
    throw e;
  }
}

export default alt.createStore(LedgerStore, "LedgerStore");



// WEBPACK FOOTER //
// ./src/app/stores/LedgerStore.js